import React, { useEffect, useState } from "react";
import { ContentContainer } from "@layout";
import { useLazyQuery, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  PARTNER_CATEGORY_FOR_PARTNER,
  PARTNER_TYPE_FOR_PARTNER,
  SEARCH_PARTNERS_FOR_TABLE,
} from "../../../constants/graphql/partners-query";
import {
  getPartnerCategoryReducer,
  getPartnerTypeReducer,
} from "../../../features/partner-table/partner-table-slice";
import {
  LoadingComponent,
  Button,
  Select,
  Modal,
  NoDataFoundTemplate,
  MultiSelect,
} from "../../../components/core";
import { partnerFeatures } from "../../../constants/partners";
import RadioButtonV2 from "../../../components/core/checkbox-v2";
import NewPartnerTable from "./components/new-partner-table";
import { Strings } from "../../../constants/strings";

const partnerStatus2 = ["Suspended", "Active"];
export default function Partners() {
  const [filterVariables, setFilterVariables] = useState({
    partnerCategory: -1,
    partnerTypeId: -1,
    enabledFeatures: [],
    withSuperUser: null,
  });

  // table visibility
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [isClicked, setIsCliked] = useState(false);
  const [filterButtonClicked, setFilterButtonClicked] = useState(false);

  // idk why the reducers arent working as expected pls!!!
  const [mappedCategoryData, setMappedCategoryData] = useState([]);

  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions,
  );
  // utils
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Redux States
  const searchData = useSelector((state) => state.searchPartner.searchData);

  // Graphql
  const [searchPartners, { data: partnerData, loading }] = useLazyQuery(
    SEARCH_PARTNERS_FOR_TABLE,
    { fetchPolicy: "no-cache" },
  );
  const partnerTypes = useQuery(PARTNER_TYPE_FOR_PARTNER, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const partnerCategory = useQuery(PARTNER_CATEGORY_FOR_PARTNER);
  const [partnerType, resultFetchChartData] = useLazyQuery(
    PARTNER_TYPE_FOR_PARTNER,
    { fetchPolicy: "no-cache" },
  );
  const [finalPartnerCategory, setFinalPartnerCategory] = useState([]);
  const [finalPartnerType, setFinalPartnerType] = useState([]);
  useEffect(() => {
    if (partnerCategory.data) {
      var tempArr = [
        {
          value: "-1",
          name: "-- ALL -- ",
        },
      ];
      partnerCategory.data.partnerCategories.forEach((e) => {
        tempArr.push({ name: e.partnerCategory, value: e.partnerCategoryNo });
      });
      setFinalPartnerCategory(tempArr);
    }
  }, [partnerCategory.data]);
  useEffect(() => {
    // setFinalPartnerType([]);
    // setselectedPartnerType("-2");
    if (resultFetchChartData.data) {
      var tempArr = [];
      resultFetchChartData.data.partnerTypes.forEach((e) => {
        tempArr.push({ name: e.partnerType, value: e.partnerTypeId });
      });
      setFinalPartnerType(tempArr);
      // console.log(setFinalPartnerType);
    }
  }, [resultFetchChartData.data]);

  // uncomment
  useEffect(() => {
    if (
      filterVariables.partnerCategory === -1 ||
      filterVariables.partnerCategory === "-1"
    ) {
      setFilterVariables({
        ...filterVariables,
        partnerTypeId: -1,
      });
    }
  }, [filterVariables.partnerCategory]);
  // Local States
  const [searchResultSentence, setSearchResultSentence] = React.useState("");

  function getSearchResultSentence() {
    var sentence = `Search Result for

	  ${
      finalPartnerCategory.find(
        (x) => x.value === parseInt(filterVariables.partnerCategory),
      )
        ? `
      ${
        finalPartnerCategory.find(
          (x) => x.value === parseInt(filterVariables.partnerCategory),
        ).name
      } Partner Category
    `
        : `All Partner Category`
    }
  
  
    ${
      finalPartnerType.find(
        (x) => x.value === parseInt(filterVariables.partnerTypeId),
      )
        ? ` and
        ${
          finalPartnerType.find(
            (x) => x.value === parseInt(filterVariables.partnerTypeId),
          ).name
        }
        Partner Type
      `
        : ` and All Partner Type`
    }
    `;
    return sentence;
  }

  const validateSearchParams = () => {
    // If both partner category and partner type are invalid
    if (
      filterVariables.partnerCategory === "-2" ||
      filterVariables.partnerTypeId === "-2"
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title_search_criteria,
        message: Strings.popup_error_title_search_criteria,
        open: true,
        actions: (
          <div className="gap-2 w-full mx-auto">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });

      return;
    }

    // If partner type is -1 (ALL),  show error
    // if (
    //   filterVariables.partnerCategory !== -1 &&
    //   filterVariables.partnerCategory !== "-1" &&
    //   filterVariables.partnerTypeId === -1
    // ) {
    //   setValidation({
    //     icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    //     title: "Incomplete Search Criteria",
    //     message: "Please select a valid partner type to proceed.",
    //     open: true,
    //     actions: (
    //       <div className="gap-2 w-full mx-auto">
    //         <Button
    //           onClick={() => setValidation({ open: false })}
    //           value={"OK"}
    //           className={"p-2 w-full"}
    //         />
    //       </div>
    //     ),
    //   });
    //   return;
    // }
    else {
      handleSearchPartners();
      setMappedCategoryData([]);
    }

    // setIsCliked(true);
    // setFilterButtonClicked(true);
  };

  const buildVariables = () => {
    let updatedVars = {
      operatorId: JSON.parse(localStorage.getItem("user")).operator_id,
      partnerTypeId: filterVariables.partnerTypeId, // Initially add it
    };

    if (filterVariables.partnerCategory !== -1) {
      updatedVars.partnerCategoryId = filterVariables.partnerCategory;
    }

    // Delete if it's -1
    if (filterVariables.partnerTypeId === -1) {
      delete updatedVars.partnerTypeId;
    }

    if (filterVariables.enabledFeatures.length > 0) {
      updatedVars.selectedFeatures = filterVariables.enabledFeatures.map(
        (feature) => feature.value,
      );
    }

    if (filterVariables.withSuperUser !== null) {
      updatedVars.isSuperadmin =
        filterVariables.withSuperUser === "1" ? true : false;
    }

    return updatedVars;
  };

  const handleSearchPartners = () => {
    const variables = buildVariables();

    searchPartners({
      variables: variables,
    })
      .then((data) => {
        if (data?.data?.searchCouriers) {
          setSearchResultSentence(getSearchResultSentence());
          // setPartnerCategoryData(data.data.searchCouriers);
          setIsCliked(true);
        } else {
          setIsCliked(true);
        }
      })
      .catch((error) => {
        console.error("Search error:", error);
        setIsCliked(false); // Reset on error
      });
  };
  useEffect(() => {
    if (partnerData && partnerData.searchCouriers.length > 0) {
      const map = partnerData.searchCouriers.map((couriers) => {
        let enabledFeaturesList = [];

        const {
          companyNickname,
          featuresCod,
          featuresReturns,
          featuresShipout,
          loadBalance,
          partnerId,
          partnerCategory,
          partnerAccounts, // Fixed: removed the conditional inside destructuring
          partnerStatus,
          partnerType,
          walletBalance,
        } = couriers;

        // Determine adminAccess based on partnerAccounts
        const adminAccess = partnerAccounts && partnerAccounts.length > 0;

        if (featuresCod === 1) {
          enabledFeaturesList.push("Payment on Delivery");
        }
        if (featuresShipout === 1) {
          enabledFeaturesList.push("Shipout service");
        }
        if (featuresReturns === 1) {
          enabledFeaturesList.push("Accepts returns");
        }

        return {
          monthlyFee: partnerType?.monthlyFee, // Added optional chaining for safety
          partner: companyNickname,
          featuresCod,
          featuresReturns,
          featuresShipout,
          loadBalance,
          partnerCategory,
          adminAccess,
          partnerId,
          partnerStatus:
            partnerStatus2[partnerStatus] === undefined
              ? "Unknown"
              : partnerStatus2[partnerStatus],
          partnerType,
          walletBalance,
          enabledFeatures: enabledFeaturesList?.join(", "),
        };
      });

      setMappedCategoryData(map);
      setIsTableVisible(true);
    } else {
      setMappedCategoryData([]);
      setIsTableVisible(false);
    }
  }, [partnerData]);

  React.useEffect(() => {
    if (partnerTypes.data) {
      let tempData = [];
      partnerTypes.data.partnerTypes.forEach((element) => {
        tempData.push({
          value: element.partnerTypeId,
          name: element.partnerType,
        });
      });
      dispatch(getPartnerTypeReducer(tempData));
    }
  }, [partnerTypes.data]);
  React.useEffect(() => {
    if (partnerCategory.data) {
      let tempData = [];
      partnerCategory.data.partnerCategories.forEach((element) => {
        tempData.push({
          value: element.partnerCategoryId,
          name: element.partnerCategory,
        });
      });
      dispatch(getPartnerCategoryReducer(tempData));
    }
  }, [partnerCategory.data]);

  const handleFilterChange = (e, field) => {
    // For checkboxes, use e.target.checked to get true/false
    // Then convert to "1" or "0" (or whatever values you need)
    const value =
      e.target.type === "checkbox"
        ? e.target.checked
          ? "1"
          : "0"
        : e.target.value;

    setFilterVariables({
      ...filterVariables,
      [field]: value,
    });
  };

  useEffect(() => {
    if (filterVariables.partnerCategory !== -1) {
      partnerType({
        variables: {
          operatorId: JSON.parse(localStorage.getItem("user")).operator_id,
          partnerCategoryNo: filterVariables.partnerCategory,
        },
      });
    }
  }, [filterVariables.partnerCategory]);

  const handleAddPartnerAccount = (rowData, type) => {
    console.log({ rowData, type });
    let partner = "new";
    let operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
    console.log("HELLO HELLO HELLO");
    if (type === "existing" && rowData.partnerId) {
      partner = parseInt(rowData.partnerId);
    }

    // TODO: AWA NALANG AYUSIN MO NA
    window.open(`partners/add-profile/${operatorId}/${partner}`, "_blank");
  };

  const handleEditClick = (rowData) => {
    let operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
    console.log("HI HI HI");

    window.open(
      `partners/partner-profile/${operatorId}/${rowData.partnerId}`,
      "_blank",
    );
  };

  return (
    <ContentContainer containerTitle="Partners">
      {/* filter fields */}
      <div className="grid grid-cols-12 gap-2">
        <div className="col-span-12 md:col-span-6 space-y-2">
          <div className="font-bold">Partner Details</div>
          <div className="px-3 space-y-2">
            <div className="grid grid-cols-9">
              <div className="col-span-9 md:col-span-3">Partner Category: </div>
              <div className="col-span-9 md:col-span-6">
                <Select
                  onChange={(e) => {
                    handleFilterChange(e, "partnerCategory");
                  }}
                  items={finalPartnerCategory}
                  value={filterVariables.partnerCategory}
                  // defaultOption={{ value: "-2", name: "-- Select Partner Category --" }}
                />
              </div>
            </div>

            {/* partner type */}
            <div className="grid grid-cols-9">
              <p className="col-span-9 md:col-span-3">Partner Type: </p>
              <div className="col-span-9 md:col-span-6">
                <Select
                  onChange={(e) => {
                    handleFilterChange(e, "partnerTypeId");
                  }}
                  className="col-span-2"
                  items={[
                    {
                      value: "-1",
                      name: "-- ALL -- ",
                    },
                    ...finalPartnerType,
                  ]}
                  value={filterVariables.partnerTypeId}
                  disabled={
                    filterVariables.partnerCategory === -1 ||
                    filterVariables.partnerCategory === "-1"
                  }
                />
              </div>
            </div>

            {/* enabled features */}
            <div className="grid grid-cols-9">
              <p className="col-span-9 md:col-span-3">Enabled Features: </p>
              <div className="col-span-9 md:col-span-6">
                <MultiSelect
                  onChange={(e) => {
                    handleFilterChange(e, "enabledFeatures");
                  }}
                  className="col-span-2"
                  items={
                    // [
                    // {
                    //   value: -1,
                    //   label: "-- ALL Features-- ",
                    // },
                    partnerFeatures
                    // ]
                  }
                  placeholder={`${
                    filterVariables.enabledFeatures.length < 1
                      ? "-- ALL Features -- "
                      : "Select..."
                  }`}
                  value={filterVariables.enabledFeatures}
                  disabled={
                    filterVariables.partnerCategory === "-1" ||
                    filterVariables.partnerCategory === -1
                  }
                />
              </div>
            </div>
          </div>

          <div className="font-bold">Partner Account</div>
          <div className="px-3 space-y-2">
            <div className="grid grid-cols-9 items-center">
              <div className="col-span-9 md:col-span-3">
                With Superadmin account?:{" "}
              </div>
              <div className="col-span-9 md:col-span-6">
                <div className="grid grid-cols-12 gap-4 py-3">
                  <div className="col-span-3">
                    <RadioButtonV2
                      className="mr-2"
                      type="radio"
                      value={`1`}
                      label="Yes"
                      checked={filterVariables.withSuperUser === "1"}
                      onChange={(e) => {
                        handleFilterChange(e, "withSuperUser");
                      }}
                    />
                    {/* <label htmlFor="checkbox1" className="text-sm">
                              1
                            </label> */}
                  </div>
                  <div className="col-span-3">
                    <RadioButtonV2
                      type="radio"
                      className="mr-2 p-0"
                      value={`2`}
                      label="No"
                      checked={filterVariables.withSuperUser === "2"}
                      onChange={(e) => {
                        handleFilterChange(e, "withSuperUser");
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* with super user account? */}
        </div>
        <div className="col-span-6"></div>

        {/* <div></div>
        <p className="my-auto col-span-1"> </p> */}

        <div className="col-span-1 md:col-span-12">
          {/* <div></div> */}
          <div className="grid grid-cols-4 gap-4">
            <Button
              onClick={validateSearchParams}
              disabled={loading}
              className="col-span-3 md:col-span-1 h-10"
              value={"Search"}
            />
            <button
              className="flex items-center gap-2 hover:text-blue-500 cursor-pointer underline"
              onClick={() => {
                setFilterVariables({
                  ...filterVariables,
                  partnerCategory: -1,
                  partnerTypeId: -1,
                  enabledFeatures: [],
                  withSuperUser: null,
                });

                setIsCliked(false);
              }}
            >
              <i className="fas fa-undo my-auto"></i>
              <span>Reset</span>
            </button>
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
      <div className="mt-2"></div>
      <Button
        className={`p-2 ${
          accessPermission.partners === 1 || accessPermission.partners === "1"
            ? "hidden"
            : ""
        }`}
        value={"Add Partner"}
        onClick={() => {
          handleAddPartnerAccount({}, "new");
          // window.open(`/operator/admin/partners/add-profile`, "_blank");
        }}
        // onClick={() => navigate("add-profile")}
        disabled={
          loading ||
          accessPermission.partners === 1 ||
          accessPermission.partners === "1"
        }
      />
      <div className="mt-2"></div>

      {loading && <LoadingComponent />}
      {!loading && isClicked && mappedCategoryData.length > 0 && (
        <NewPartnerTable
          data={mappedCategoryData}
          searchResultSentence={searchResultSentence}
          handleAddPartnerAccount={handleAddPartnerAccount}
          handleEditClick={handleEditClick}
          accessPermissions={accessPermission}
        />
      )}
      {!loading && isClicked && mappedCategoryData.length === 0 && (
        <NoDataFoundTemplate />
      )}

      {/* {mappedCategoryData.length < 0 && <NoDataFoundTemplate />} */}

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
}
